/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'async-file-upload';
const prefix = `${moduleName}.${componentName}`;

export const browseBtnLabel = `${prefix}.browseBtnLabel`;
export const uploadBtnLabel = `${prefix}.uploadBtnLabel`;

export const ENGLISH = {
    [browseBtnLabel]: 'Browse',
    [uploadBtnLabel]: 'Upload',
};
